import { type RouteRecordRaw } from 'vue-router'

import { canAccessLaunch } from '../canAccessLaunch'

export const launchOnboardingRouter: RouteRecordRaw[] = [
  {
    component: async () => await import('../views/LaunchOnboardingView.vue'),
    meta: {
      authZ: ({ user }) => canAccessLaunch(user),
      title: 'launch',
    },
    name: 'brand.launch-onboarding',
    path: 'launch-onboarding',
  },
]
